import { Text } from '@chakra-ui/react'

export const WhiteSpace = () => <Text as='span' whiteSpace='pre-wrap'> </Text>
